var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.2 20.2",
    style: {
      enableBackground: "new 0 0 20.2 20.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#471c09;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,16.4c0,2.1-1.7,3.8-3.8,3.8H3.8c-2.1,0-3.8-1.7-3.8-3.8V3.8C0,1.7,1.7,0,3.8,0h12.6 c2.1,0,3.8,1.7,3.8,3.8V16.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.7,10.4c0-1.8,0-3.7,0-5.5c0-0.5,0.3-0.8,0.8-0.8c1.8,0,3.6,0,5.3,0c0.5,0,0.8,0.3,0.8,0.8 c0,3.7,0,7.3,0,11c0,0.5-0.3,0.8-0.8,0.8c-1.8,0-3.6,0-5.3,0c-0.5,0-0.8-0.3-0.8-0.8C6.7,14.1,6.7,12.2,6.7,10.4z M8.9,4.5 C8.9,4.5,8.9,4.5,8.9,4.5c-0.5,0-1,0-1.5,0c-0.3,0-0.4,0.1-0.4,0.4c0,3.7,0,7.3,0,11c0,0.3,0.1,0.4,0.4,0.4c1.8,0,3.5,0,5.3,0 c0.3,0,0.4-0.1,0.4-0.4c0-3.6,0-7.3,0-10.9c0,0,0-0.1,0-0.1c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.4,0-0.7,0c-0.3,0-0.6,0-0.9,0 c-0.1,0.2-0.1,0.4-0.2,0.6c0,0.1-0.1,0.2-0.2,0.2c-0.5,0-1,0-1.5,0c-0.1,0-0.2,0-0.2-0.2C9,4.9,9,4.7,8.9,4.5z M9.4,4.5 c0,0.1,0.1,0.3,0.1,0.4c0.4,0,0.9,0,1.3,0c0-0.1,0.1-0.3,0.1-0.4C10.3,4.5,9.9,4.5,9.4,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,16.1c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2c0.4,0,0.8,0,1.2,0 c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.2C10.5,16.1,10.3,16.1,10.1,16.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderList);
export default __webpack_public_path__ + "static/media/order-list.53cf98c798e074abbe7181762fcd7c28.svg";
export { ForwardRef as ReactComponent };